import styled from 'styled-components';
import { isMobile } from 'utils/is-mobile';

export const New = styled.span`
  height: 12px;
  font-size: 7px;
  background-color: var(--v3-error-color);
  color: var(--v3-black-0);
  padding: 1px 6px;
  border-radius: 4px;
  letter-spacing: 0.1px;
  line-height: 10px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  overflow: hidden;
  letter-spacing: 0.1px;
  text-overflow: ellipsis;
  color: var(--v3-text-color);
`;

export const EachWayContainer = styled.span`
  font-size: 12px;
  color: var(--v3-text-color);
  user-select: none;
`;

export const Extra = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Header = styled.div<{ $isActive?: boolean }>`
  background-color: var(--v3-black-0);
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 12px 8px;
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  line-height: 16px;
  height: 40px;
  ${props =>
    props.$isActive
      ? `
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        &:after {
          content: '';
          position: absolute;
          left: 8px;
          right: 8px;
          bottom: 0;
        }
      `
      : isMobile()
      ? `
          border-radius: 6px;
          margin-bottom: 4px;
        `
      : `
          margin-bottom: 4px;
      `}
  ${isMobile() &&
  `
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
  `};
`;

export const Body = styled.div`
  background-color: var(--v3-black-0);
  padding-top: 4px;
  &:nth-last-child(1) {
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  ${isMobile()
    ? `
      margin-bottom: 4px;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
    `
    : `
      margin-bottom: 2px;
    `}
`;
